
<template>
  <div>
    <div class="find">
      <div class="seach-top">
        <el-form
          ref="searchForm"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >
          <el-row>
            <el-col :span="16">
              <el-row>
                <el-form-item label="课题名称">
                  <el-input
                    v-model="searchForm.ketiMingcheng"
                    placeholder="课题名称"
                    size="small"
                    clearable
                  />
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="8">
              <div class="btn-box" style="float: right;">
                <el-row>
                  <el-form-item>
                    <el-button type="primary" size="small" @click="handleAdd">
                      新增
                      <i class="el-icon-plus el-icon--right" />
                    </el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" size="small" @click="handleSearch">
                      查询
                      <i class="el-icon-search el-icon--right" />
                    </el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" size="small" @click="handleBack">
                      返回
                      <i class="el-icon-search el-icon--right" />
                    </el-button>
                  </el-form-item>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <el-table
      class="table-list"
      :border="true"
      :data="tableData"
      style="width: 100%"
      row-key="id"
      @sort-change="handleResort"
    >
      <!-- 序号 -->
      <el-table-column label="序号" type="index" width="50px" align="right" fixed="left" />

      <el-table-column prop="ketiFzrUserId" label="负责人" width="100px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.ketiFzrUserName }}
        </template>
      </el-table-column>
      <el-table-column prop="ketiMingcheng" label="课题名称" :show-overflow-tooltip="true" />
      <el-table-column prop="ketiBianhao" label="课题编号" :show-overflow-tooltip="true" />
      <el-table-column prop="jingfeiLaiyuan" label="经费来源" :show-overflow-tooltip="true" />
      <el-table-column prop="jingfeiKahao" label="经费卡号" :show-overflow-tooltip="true" />

      <el-table-column
        fixed="right"
        label="操作"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click.stop="handleEdit(scope.row)"
          >编辑</el-button>
          <!-- 申请者可修改删除 -->
          <el-button
            type="text"
            size="mini"
            @click.stop="handleDel( scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next,total,sizes"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      :total="totalCount"
      @size-change="handleSizeChange"
      @current-change="handleChangePage"
    />
    <Edit ref="edit" :entity-id="entityId" @save-success="handleSearch" />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
// import ShowUpload from './ShowUpload'
// import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import KxjCom from '@/utils/kxjcom'
import Edit from '@/views/managesystem/zy/zy0204/zy0204edit.vue'
export default {
  components: {
    // Assist,
    Edit
    // UploadExcelComponent
  },
  filters: {
    dateFmt(val) {
      return KxjCom.tableDateFormat(val)
    },
    decFmt(val) {
      return KxjCom.tableDecFormat(val)
    }
  },
  data() {
    return {
      moduleCode: 'zy0203',
      tableHeader: [],
      totalCount: 0,
      tableData: [],
      allComboxData: [],
      searchForm: {
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: '',
        keyWord: '',
        statusDictKey: 'F0104'
      },
      uploadData: [],
      uploadFormShow: false,
      ketiMemberList: [], // 课题组成员
      entityId: null,
      rebuyEntityId: null,
      expandKeys: [],
      subTableData: []
    }
  },
  computed: {
    getSpac() {
      return '　'
    }
  },
  // 触发
  activated() {
    this.handleSearch()
  },
  // 初期化数据
  created() {
    // 绑定检索
    this.$bus.$off('handleReload')
    this.$bus.$on('handleReload', this.handleSearch)

    this.handleSearch()
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('F01;F02').then(res => {
      this.allComboxData = res.data.result
    })

    const loading = this.$loading(KxjCom.loadOptions)
    pathReq.getForm('api/services/app/Com/GetKetizuMember').then(resp => {
      this.ketiMemberList = resp.data.result
      loading.close()
    })
  },
  mounted() {},
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    // 每页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.handleSearch()
    },
    // 切页
    handleChangePage(page) {
      this.searchForm.pageNumber = page
      this.handleSearch()
    },
    // 排序
    handleResort(column) {
      this.searchForm.sortKey = column.prop
      this.searchForm.sortOrder = column.order
      this.handleSearch()
    },
    // 新增
    handleAdd() {
      this.entityId = null
      this.$refs.edit.show()
    },
    handleEdit(row) {
      this.entityId = row.id
      this.$refs.edit.show()
    },
    // 删除-申请信息
    handleDel(row) {
      const that = this
      this.$confirm('确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(KxjCom.loadOptions)
        const path = '/api/services/app/zy0204/Deletezy0204'
        pathReq.dataDelete(path, row.id).then(res => {
          this.$message.success('删除成功!')
          that.handleSearch()
        })
      })
        .catch(() => {
        })
    },
    // 查询
    handleSearch() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      var path = '/api/services/app/zy0204/GetPagedListzy0204s'
      pathReq
        .getList(path, that.searchForm)
        .then(res => {
          loading.close()
          that.totalCount = res.data.result.totalCount
          that.tableData = res.data.result.items
        })
    },
    /** 返回资源管理主页 */
    handleBack() {
      this.$router.push('/zy/zy02')
    },
    // 导出
    handleExport() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          '状态',
          '试剂耗材名称',
          '品牌',
          '规格(数量)',
          '规格(单位)',
          '采购数量',
          '库管员',
          '采购编号',
          '库名称',
          '个人库',
          '入库日期',
          '结余',
          '科室',
          '课题负责人',
          '经费来源',
          '经费卡号',
          '课题编号',
          '课题名称',
          '实验名称',
          '用途',
          '报销者',
          '已报销'
        ]
        const filterVal = [
          'statusDictName',
          'shijihaocaiMingcheng',
          'pingpai',
          'guigeQty',
          'guigeUnit',
          'shenqingQty',
          'rukuzheUserName',
          'stockInCode',
          'kumingchengDictName',
          'kumingcheng2',
          'rukuRiqi',
          'jieyu',
          'keshi',
          'ketiFzrUserName',
          'jingfeiLaiyuan',
          'jingfeiKahao',
          'ketiBianhao',
          'ketiMingcheng',
          'shiyanMingcheng',
          'yongtu',
          'baoxiaozheUserName',
          'isBaoxiao'
        ]
        const list = this._data.tableData
        const data = KxjCom.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '试剂耗材', // 非必填
          autoWidth: true, // 非必填
          bookType: 'xlsx' // 非必填
        })
        this.downloadLoading = false
      })
    }

  }
}
</script>

<style scoped>
/* ffc059 */
.upload-btn{
  margin-left: -10px;
}
</style>
